function Champions() {
  return (
    <section className="w-full bg-dark">
      <img
        src="/Assets/Images/MedalGroup.jpg"
        alt="TNL Champion Medals"
        className="w-full object-cover"
      />
    </section>
  );
}

export default Champions;
